import(/* webpackMode: "eager", webpackExports: ["WalletProvider"] */ "/home/ubuntu/download/69b08082886e100014b1feb8/nordic_trading_platform/src/lib/wallet/WalletContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69b08082886e100014b1feb8/nordic_trading_platform/src/styles/index.css");
